import { Injectable } from '@angular/core';
import { EntityState, EntityStore, StoreConfig } from '@datorama/akita';

import { PortfolioSimulationParameters, PortfolioSimulationPortfolio } from '@core/models/portfolio-simulation.model';

export interface PortfolioSimulationState extends EntityState<PortfolioSimulationPortfolio> {
  parameters: PortfolioSimulationParameters | null;
  loading: boolean;
  error: string | null;
}

export function createInitialState(): PortfolioSimulationState {
  return {
    parameters: null,
    loading: false,
    error: null,
  };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'portfolio-simulation', idKey: 'id', resettable: true })
export class PortfolioSimulationStore extends EntityStore<PortfolioSimulationState> {
  constructor() {
    super(createInitialState());
  }

  setParameters(parameters: PortfolioSimulationParameters): void {
    this.update({ parameters });
  }

  setLoading(loading: boolean): void {
    this.update({ loading });
  }

  setErrorState(error: string | null): void {
    this.update({ error });
  }
}
